import { render, staticRenderFns } from "./OrderContributors.vue?vue&type=template&id=775594f0&scoped=true"
import script from "./OrderContributors.vue?vue&type=script&lang=js"
export * from "./OrderContributors.vue?vue&type=script&lang=js"
import style0 from "./OrderContributors.vue?vue&type=style&index=0&id=775594f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "775594f0",
  null
  
)

export default component.exports